{
  "de": {
    "placeholders": {
      "name": "Name",
      "description": "Beschreibung",
      "amount": "Betrag",
      "login": "Benutzername oder E-Mail",
      "username": "Benutzername",
      "twoFactorCode": "Zwei-Faktor-Code",
      "confirmationCode": "Bestätigungscode",
      "email": "E-Mail",
      "password": "Passwort",
      "passwordConfirmation": "Passwort bestätigen",
      "homepage": "Homepage",
      "discord": "Discord-Server",
      "youtube": "Youtube-Kanal",
      "twitch": "Twitch-Kanal",
      "distance": "Entfernung",
      "color": "Farbe",
      "title": "Titel",
      "classification": "Kampf, Industrie, Multi-Role...",
      "focus": "Leichter Jäger, Bergbau, Fracht...",
      "minSize": "Snub, klein, mittel...",
      "maxSize": "mittel, groß, capital...",
      "minCrew": "Min. Besatzung",
      "minCargo": "SCU",
      "modelId": "Nach einem Schiff suchen",
      "scenario": "Xenothreat, Pirate Swarm, Bounty…",
      "briefing": "Ausführliches Briefing — Comms, Rufzeichen, Einsatzregeln…",
      "location": "Stanton, Pyro, ARC-L1…",
      "meetupLocation": "Daymar, Raumhafen — Hangar 4…",
      "maxAttendees": "Optionales Limit",
      "autoLockMinutesBefore": "60",
      "timezone": "UTC",
      "startsAt": "Startdatum & -zeit wählen",
      "endsAt": "Enddatum & -zeit wählen (optional)",
      "notes": "Bringe extra Munition mit, kann Support fliegen, ETA in 10…",
      "signup-status": "Bestätigt oder vorläufig?",
      "features": {
        "username": "Username or User ID",
        "name": "Funktionsname"
      },
      "fleetInviteToken": "Flotteneinladung",
      "quicksearch": {
        "models": "Avenger, Carrack, Cutlass...",
        "hangar": "Enterprise, Andromeda..."
      },
      "search": {
        "default": "Search the Verse...",
        "roadmap-progress-tracker": "Suchen"
      },
      "home": {
        "catalogueSearch": "Suchen..."
      },
      "image": {
        "caption": "Beschriftung"
      },
      "model": {
        "length": "Länge",
        "beam": "Breite",
        "height": "Höhe",
        "price": "Preis",
        "pledgePrice": "Pledge-Preis",
        "onSale": "Im Verkauf",
        "mass": "Masse",
        "crew": "Besatzung",
        "storeUrl": "Store URL",
        "salesPageUrl": "Verkaufsseiten-URL",
        "rsiId": "RSI ID",
        "scKey": "SC Key",
        "erkulIdentifier": "Erkul Identifier",
        "productionNote": "Produktionsnotiz",
        "scmSpeed": "SCM Geschwindigkeit",
        "scmSpeedBoosted": "SCM Geschwindigkeit (Boosted)",
        "maxSpeed": "Max Geschwindigkeit",
        "reverseSpeedBoosted": "Rückwärtsgeschwindigkeit (Boosted)",
        "quantumFuelTankSize": "Quantum-Treibstofftankgröße",
        "hydrogenFuelTankSize": "Wasserstoff-Treibstofftankgröße",
        "yaw": "Gieren",
        "pitch": "Nicken",
        "roll": "Rollen",
        "yawBoosted": "Gieren (Boosted)",
        "pitchBoosted": "Nicken (Boosted)",
        "rollBoosted": "Rollen (Boosted)",
        "fleetchartOffsetLength": "Flottenkarten-Versatz Länge",
        "fleetchartOffsetBeam": "Flottenkarten-Versatz Breite",
        "extendedLength": "Ausgefahrene Länge",
        "extendedBeam": "Ausgefahrene Breite",
        "extendedHeight": "Ausgefahrene Höhe",
        "extendedFleetchartOffsetLength": "Ausgefahrener Flottenkarten-Versatz Länge",
        "extendedFleetchartOffsetBeam": "Ausgefahrener Flottenkarten-Versatz Breite",
        "landedLength": "Länge gelandet",
        "landedBeam": "Breite gelandet",
        "landedHeight": "Höhe gelandet",
        "landedFleetchartOffsetLength": "Flottenübersicht-Versatz Länge gelandet",
        "landedFleetchartOffsetBeam": "Flottenübersicht-Versatz Breite gelandet",
        "cargo": "Fracht",
        "baseModel": "Basismodell"
      },
      "cargoHold": {
        "offsetX": "Versatz X",
        "offsetY": "Versatz Y",
        "offsetZ": "Versatz Z",
        "rotation": "0 or 90",
        "maxLoadableContainerSizeScu": "Grid-Maximum"
      },
      "manufacturer": {
        "longName": "Vollständiger Name",
        "code": "Code",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "Was ist passiert?",
        "body": "Markdown. Erscheint im Posteingang und in der E-Mail.",
        "discordPart": "Eine Nachricht",
        "socialPart": "Ein Post",
        "link": "/fleets/"
      },
      "fundingGoal": {
        "title": "Serverkosten, Domain, Discord...",
        "description": "Optionaler öffentlicher Kontext",
        "amount": "100,00",
        "currency": "EUR",
        "effectiveFrom": "2026-01-01",
        "endedAt": "leer lassen, wenn laufend"
      },
      "gameEvent": {
        "title": "Invictus Launch Week",
        "description": "Was passiert und warum Piloten hingehen sollten",
        "location": "New Babbage, microTech",
        "url": "https://robertsspaceindustries.com/..."
      },
      "supporterContribution": {
        "name": "Öffentlich angezeigter Name",
        "amount": "5,00",
        "currency": "EUR",
        "startedAt": "2026-01-01",
        "endedAt": "2026-12-31",
        "payerEmail": "donor@example.com",
        "claimKey": "FY-7K2M-9QXD",
        "note": "Optionale interne Notiz"
      },
      "component": {
        "componentType": "Komponententyp",
        "componentSubType": "Komponenten-Untertyp",
        "size": "Größe",
        "grade": "Qualität",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "modelPaint": {
        "pledgePrice": "Pledge-Preis",
        "productionStatus": "Produktionsstatus",
        "productionNote": "Produktionshinweis"
      },
      "fleet": {
        "headquarters": "Wo ist eure Flotte stationiert?",
        "fid": "Flotten-ID",
        "rsiSid": "RSI SID",
        "ts": "Teamspeak-Server",
        "description": "Beschreibung",
        "discord": {
          "guildId": "z. B. 123456789012345678",
          "channelId": "Voice-Channel-ID für das Event",
          "webhookUrl": "https://discord.com/api/webhooks/…",
          "webhookConfigured": "Gespeichert — leer lassen, um die bestehende zu behalten"
        },
        "homepage": "Homepage",
        "twitch": "Twitch-Kanal",
        "youtube": "Youtube-Kanal"
      },
      "adminUser": {
        "passwordConfirmation": "Passwort bestätigen"
      },
      "user": {
        "rsiHandle": "RSI-Handle",
        "location": "e.g. Berlin, Germany",
        "currentSystem": "z. B. Lorville, Port Tressler, Pyro"
      },
      "oauthApplication": {
        "name": "Meine Anwendung",
        "redirectUri": "https://example.com/callback",
        "scopes": "öffentlich"
      },
      "vehicle": {
        "serial": "Serial"
      },
      "itemPrice": {
        "price": "0.00",
        "location": "Standort",
        "locationUrl": "Standort-URL"
      },
      "video": {
        "url": "YouTube Video ID"
      },
      "modelModule": {
        "name": "Modulname",
        "price": "0.00",
        "pledgePrice": "0.00",
        "productionStatus": "Angekündigt, Flugbereit, Im Konzept...",
        "scKey": "SC Key",
        "search": "Module nach Name suchen..."
      },
      "modelUpgrade": {
        "name": "Upgrade-Name",
        "pledgePrice": "0.00",
        "description": "Beschreibung"
      },
      "modelModulePackage": {
        "name": "Paketname",
        "pledgePrice": "0.00",
        "description": "Beschreibung"
      },
      "dock": {
        "name": "Dock-Name",
        "length": "Länge in m",
        "beam": "Breite in m",
        "height": "Höhe in m"
      },
      "modelPosition": {
        "name": "Positionsname",
        "position": "0"
      },
      "logistics": {
        "inventoryName": "Main Depot, Cargo Bay...",
        "description": "Optional details about this inventory",
        "location": "e.g. Port Olisar, Area18",
        "itemName": "Titanium, Medical Supplies..."
      },
      "filters": {
        "vehicles": {
          "name": "Enterprise, Andromeda...",
          "priceLt": "Preis <=",
          "priceGt": "Preis >="
        },
        "models": {
          "name": "Gladius, Andromeda...",
          "classification": "Fahrzeug, Jäger, Fracht...",
          "manufacturer": "Origin, Robert Space Industries, Aegis...",
          "onSale": "Ja oder Nein",
          "productionStatus": "Angekündigt, Flugbereit, Im Konzept..."
        },
        "modelModules": {
          "name": "Bio Dome, Cargo Module..."
        },
        "manufacturers": {
          "name": "Origin, Robert Space Industries, Aegis..."
        },
        "supporterContributions": {
          "name": "Alice, Bob...",
          "startedAtGteq": "2026-01-01",
          "startedAtLteq": "2026-12-31"
        },
        "adminNotifications": {
          "search": "Titel oder Inhalt..."
        },
        "users": {
          "search": "Benutzername oder E-Mail",
          "username": "Benutzername",
          "rsiHandle": "RSI-Handle",
          "email": "E-Mail"
        },
        "components": {
          "name": "Name",
          "description": "Quantenantrieb, Panzerung...",
          "manufacturer": "Behring, Ascension Astro, Juno Starwerk..."
        },
        "fleets": {
          "name": "Name",
          "fid": "FID",
          "memberCountGteq": "Mindestens Mitglieder",
          "memberCountLteq": "Höchstens Mitglieder",
          "createdOnGteq": "2026-01-01",
          "createdOnLteq": "2026-12-31",
          "members": {
            "search": "Benutzername oder Spitzname"
          }
        },
        "destroyedFleets": {
          "nameOrFid": "Name oder FID"
        },
        "commodities": {
          "name": "Agricium, Laranite, Quantainium...",
          "description": "ore, ammunition, material...",
          "uexCode": "UEX Code"
        },
        "equipment": {
          "name": "Arclight, Pembroke, Novikov..."
        },
        "notifications": {
          "search": "Titel oder Inhalt..."
        },
        "blueprints": {
          "name": "Greatsword, Testudo, Omnisky...",
          "material": "Eisen, Titan, Aphorit...",
          "craftableType": "Komponente, Ausrüstung...",
          "source": "Bekannt, unbekannt..."
        },
        "fleetDirectory": {
          "search": "Name, FID oder SID...",
          "memberCountGteq": "Mindestens Mitglieder"
        }
      },
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "size": "Size",
        "grade": "Grade",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "relationships": {
        "user": {
          "handle": "Benutzername der Person"
        },
        "fleet": {
          "handle": "Slug der Flotte"
        }
      },
      "reward": "Belohnung in aUEC",
      "crewLimit": "Kein Limit",
      "deadline": "Keine Frist",
      "itemName": "Was geliefert wird",
      "itemQuantity": "Wie viel",
      "itemQuality": "600"
    }
  }
}
